import { EventEmitter } from '@angular/core';
import { FormArray } from '@angular/forms';
var MfaStepComponent = /** @class */ (function () {
    function MfaStepComponent() {
        this.insertVerificationCode = new EventEmitter();
        this.toRecoveryCodeStep = new EventEmitter();
    }
    return MfaStepComponent;
}());
export { MfaStepComponent };
